var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"picture-wrapper__bundle"},_vm._l((_vm.packageIcons),function(icon){return _c(_setup.ProviderIcon,{key:icon.iconWide,staticClass:"icon",attrs:{"iconUrl":icon.iconWide,"providerShortName":icon.shortName}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }